import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export type DetailFieldProps = {
  label: string
  value: ReactNode
  multiline?: boolean
  className?: string
}

export const DetailField = ({
  label,
  value,
  multiline = false,
  className,
}: DetailFieldProps) => (
  <div
    className={cn(
      'flex flex-row gap-4',
      multiline ? 'items-start' : 'items-center',
      className
    )}
  >
    <dt
      className={cn(
        'w-44 shrink-0 text-sm font-semibold text-foreground',
        multiline && 'pt-4'
      )}
    >
      {label}
    </dt>
    <dd
      className={cn(
        'min-w-0 flex-1 rounded-button-sm border border-foreground/10 bg-white px-4 py-4 text-sm text-foreground',
        multiline && 'min-h-24 whitespace-pre-wrap'
      )}
    >
      {value}
    </dd>
  </div>
)
